import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { useScrollY } from "@/hooks/useScrollY";

const FADE_START = 80;
const FADE_END = 380;

function clamp01(v: number): number {
	return v < 0 ? 0 : v > 1 ? 1 : v;
}

export function ScrollHint(): ReactNode {
	const { t } = useTranslation();
	const scrollY = useScrollY();
	const opacity = clamp01(1 - (scrollY - FADE_START) / (FADE_END - FADE_START));

	return (
		<div className="scroll-hint" style={{ opacity }} aria-hidden="true">
			<div className="scroll-hint__mouse">
				<span className="scroll-hint__wheel" />
			</div>
			<span className="scroll-hint__label">{t("scrollHint.label")}</span>
		</div>
	);
}
